import { render } from "./BankPayrun.vue?vue&type=template&id=2b0a5c48"
import script from "./BankPayrun.vue?vue&type=script&lang=js"
export * from "./BankPayrun.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__